export default "__VITE_ASSET__1c2f0053__"